import clsx from "clsx"
import { A } from "src/components/generic/A"
import { npPageWidthClassName } from "src/components/generic/constants"
import { Countdown } from "src/components/sale/Countdown"
import { SanityAnnouncementData } from "src/data/sanity/types"
import { getRelativeUrl } from "src/utilities/url"

export type AnnouncementProps = SanityAnnouncementData

export const Announcement = ({ href, text, countdown, countdownUntil }: AnnouncementProps) => {
  const relativeHref = getRelativeUrl(href) || ""
  const Wrapper = relativeHref ? A : "div"

  return (
    <header
      aria-label="Angebot"
      className="z-announcement-bar bg-np-red flex min-h-16 w-full items-center p-2 text-white md:min-h-10"
    >
      <Wrapper
        href={relativeHref || "#"}
        className={clsx(npPageWidthClassName, "flex flex-wrap items-center justify-center gap-2")}
      >
        {countdown && <Countdown until={countdownUntil} />}
        {text && (
          <div className="text-center text-sm leading-normal font-semibold text-balance sm:text-base">{text}</div>
        )}
      </Wrapper>
    </header>
  )
}
